import { PureComponent } from 'react'
import PropTypes from 'prop-types'

const callIf = fn => (...args) => fn && fn(...args)
const callAll = (...fns) => (...args) => fns.forEach(fn => callIf(fn)(...args))

class FormControl extends PureComponent {
  static propTypes = {
    children: PropTypes.func.isRequired
  }

  state = {
    filled: false,
    focused: false
  }

  handleFocus = () => {
    this.setState(state => !state.focused ? { focused: true } : null)
  }

  handleBlur = () => {
    this.setState(state => state.focused ? { focused: false } : null)
  }

  handleDirty = () => {
    this.setState(state => !state.filled ? { filled: true } : null)
  }

  handleClean = () => {
    this.setState(state => state.filled ? { filled: false } : null)
  }

  getInputProps = ({
    onFocus,
    onBlur,
    onFilled,
    onEmpty,
    ...props
  }) => ({
    onFocus: callAll(this.handleFocus, onFocus),
    onBlur: callAll(this.handleBlur, onBlur),
    onFilled: callAll(this.handleDirty, onFilled),
    onEmpty: callAll(this.handleClean, onEmpty),
    ...props
  })

  getStateAndHelpers() {
    return {
      ...this.state,
      getInputProps: this.getInputProps
    }
  }

  render() {
    return this.props.children(this.getStateAndHelpers())
  }
}

export default FormControl
